/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetCompetitionMyStandingRow } from '../openapi-types.gen.js';
import { type useGetCompetitionMyStandingArgs, useGetCompetitionMyStandingSpec } from '../specs/competitions.spec.gen.js';

export type { GetCompetitionMyStandingRow } from '../openapi-types.gen.js';
export type { useGetCompetitionMyStandingArgs } from '../specs/competitions.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): competitionId.
 */
const _useGetCompetitionMyStanding = createHook(useGetCompetitionMyStandingSpec);
export const useGetCompetitionMyStanding = _useGetCompetitionMyStanding as (args: useGetCompetitionMyStandingArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCompetitionMyStanding>;


/**
 * Hover/intent prefetch companion for `useGetCompetitionMyStanding`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetCompetitionMyStanding();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetCompetitionMyStanding = createPrefetchHook(useGetCompetitionMyStandingSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetCompetitionMyStandingArgs>;
